import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter , Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getStagingConfigs, deleteStagingConfig,setStagingPageInfo} from "../../actions/actionStaging.js"

class StagingConfig extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            modal: false,
            filterId: null,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteStagingAction = this.deleteStagingAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getStagingConfigs();
    }

    deleteConfirm(stagingConfigId){
        this.setState({modal: !this.state.modal,
            stagingConfigId: stagingConfigId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteStagingAction(){
        this.props.deleteStagingConfig(this.state.stagingConfigId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteStagingErrorMessage} = this.props;
        if(deleteStagingErrorMessage) {
            NotificationManager.error(deleteStagingErrorMessage,"Delete Staging Config Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Staging Config","Delete Staging Config", 3000);
            this.setState({modal: false});
            this.props.getStagingConfigs();
        }
    }

    handleDeleteError(){
        const {deleteStagingError} = this.props;
        if(deleteStagingError){
            NotificationManager.error(deleteStagingError,"Failed to Delete Staging Config", 3000);
            this.props.history.push("/staging");
        }else{
            NotificationManager.error("Failed to Delete Staging Config","Delete Staging Config", 3000);
            this.props.history.push("/staging");
        }
    }

    render() {
        if (this.props.getStagingLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        const {staging_configs} = this.props;
        
        const tableColumns = [
            {
                type: "text",
                name: "Zone",
                accessor: "zone_name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Image",
                accessor: "image_friendly_name",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Desired Sessions",
                accessor: "num_sessions",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Current Sessions",
                accessor: "num_current_sessions",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Expiration",
                accessor: "expiration",
                filterable: true,
                sortable: true
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewstaging/${item.staging_config_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updatestaging/${item.staging_config_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.staging_config_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-flask"></i> <strong>Session Staging</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createstaging" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add Config
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="staging"
                                    data={staging_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic">Close</Button>
                        <Button onClick={this.deleteStagingAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        staging_configs: state.staging.staging_configs || [],
        getStagingLoading: state.staging.getStagingLoading || false,
        getStagingErrorMessage: state.staging.getStagingErrorMessage || false,
        getStagingError: state.staging.getStagingError || null,
        deleteStagingErrorMessage: state.staging.deleteStagingErrorMessage || null,
        deleteStagingError: state.staging.deleteStagingError || null,
        deletedStaging: state.staging.deletedStaging || null,
        deleteStagingLoading: state.staging.deleteStagingLoading || null,
        pages : {pageSize : state.staging.pageSize, pageNo : state.staging.pageNo},
    }),
    dispatch => ({
        getStagingConfigs: () => dispatch(getStagingConfigs()),
        deleteStagingConfig: (data) => dispatch(deleteStagingConfig(data)),
        setPageInfo : (data)=> dispatch(setStagingPageInfo(data)),

    }))(StagingConfig);



// WEBPACK FOOTER //
// ./src/views/Staging/Staging.js